import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import styled from '@emotion/styled';
import { Box } from '@lightspeed/flame/Core';
import { theme } from '@lightspeed/flame/Core/themes/flame';
import { Divider } from '@lightspeed/flame/Divider';
import { ModalBody as FlameModalBody } from '@lightspeed/flame/Modal';
import { Text } from '@lightspeed/flame/Text';

import { removeShopAccess } from 'pages/store/actions/employeeShops';
import { getStore } from 'pages/store/selectors/employeeShops';

import ModalShopRow from './ModalShopRow';

const StyledModalBody = styled(FlameModalBody)`
  padding: ${theme.space[0]};
`;

interface Props {
  readOnly?: boolean;
}

const ModalBody: React.FC<Props> = ({ readOnly = false }) => {
  const dispatch = useDispatch();
  const { shops } = useSelector(getStore);
  const employeeShops = shops.filter((shop) => shop.hasAccess);

  const handleOnClickRemove = (shopID: number) => dispatch(removeShopAccess(shopID));

  if (!employeeShops.length) {
    return (
      <Box pb={4} pt={5} data-test="no-locations-selected">
        <Text fontWeight="bold" textAlign="center" mb={2}>
          No locations selected
        </Text>
        <Text textAlign="center" color={theme.colors['gray-600']}>
          Select a location from the menu to allow access.
        </Text>
      </Box>
    );
  }

  return (
    <StyledModalBody scroll={true}>
      {employeeShops.map((shop, index) => (
        <React.Fragment key={shop.id}>
          {index > 0 && <Divider px={3} />}
          <ModalShopRow
            onClickRemove={() => {
              handleOnClickRemove(shop.id);
            }}
            shop={shop}
            showUpdated={!shop.isDefault}
            readOnly={readOnly}
          />
        </React.Fragment>
      ))}
    </StyledModalBody>
  );
};

export default ModalBody;
